import { FC, useState } from 'react';
import { Box, Collapse } from '@mui/material';
import { Email as EmailIcon, Link as LinkIcon, ModeComment as ModeCommentIcon } from '@mui/icons-material';

import CollapsibleText from '../../../../../components/Text/CollapsibleText';
import Column from '../../../../../components/Column';
import EllipsisText from '../../../../../components/Text/EllipsisText';
import ExpandButton from '../../../../../components/Button/ExpandButton';
import OverviewList, { OverviewListItem } from '../../../../../components/List/OverviewList';

import { Campaign } from '../../../../../types/Campaign';

interface CampaignMetaOverviewListProps {
    campaign: Campaign;
}

const CampaignMetaOverviewList: FC<CampaignMetaOverviewListProps> = ({ campaign }) => {
    const [commentExpanded, setCommentExpanded] = useState<boolean>(false);

    const items: OverviewListItem[] = [
        {
            icon: EmailIcon,
            primary: 'Email for Approval',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.emailForApproval ? (
                        <EllipsisText variant="subtitle2" color="text.primary" tooltip={campaign.emailForApproval}>
                            {campaign.emailForApproval}
                        </EllipsisText>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
        },
        {
            icon: LinkIcon,
            primary: 'Inventory Provider',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.inventoryProvider ? (
                        <EllipsisText variant="subtitle2" color="text.primary" tooltip={campaign.inventoryProvider}>
                            {campaign.inventoryProvider}
                        </EllipsisText>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
        },
        {
            icon: ModeCommentIcon,
            primary: 'Comment',
            secondary: (
                <Column gap={0} alignItems="flex-end">
                    {campaign?.additionalComments ? (
                        <ExpandButton
                            variant="text"
                            expand={commentExpanded}
                            onClick={() => setCommentExpanded((prev) => !prev)}
                        >
                            Read
                        </ExpandButton>
                    ) : (
                        ' - '
                    )}
                </Column>
            ),
            tertiary:
                commentExpanded && campaign?.additionalComments ? (
                    <Collapse in={commentExpanded} timeout="auto" unmountOnExit>
                        <Box
                            sx={{
                                backgroundColor: (theme) => theme.palette.grey[100],
                                p: (theme) => theme.spacing(3),
                                borderRadius: (theme) => theme.spacing(1),
                            }}
                        >
                            <CollapsibleText text={campaign?.additionalComments as string} />
                        </Box>
                    </Collapse>
                ) : undefined,
        },
    ];

    return <OverviewList items={items} sx={{ p: 0 }} />;
};

export type { CampaignMetaOverviewListProps };
export default CampaignMetaOverviewList;
